import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { supplierApi, type Supplier } from '../../api/supplier';

export function SupplierDirectoryPage() {
  const [items, setItems] = useState<Supplier[]>([]);

  useEffect(() => {
    void supplierApi.listSuppliers().then(setItems);
  }, []);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/suppliers" className="text-sm text-slate-600 hover:underline">← Supplier hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Supplier directory</h1>
      <ul className="mt-6 space-y-2">
        {items.map((s) => (
          <li key={s.id} className="rounded border p-3 text-sm">
            {s.supplier_code} — {s.legal_name} · {s.category} · {s.status} · Health {s.health_score.toFixed(0)}%
          </li>
        ))}
        {!items.length && <li className="text-slate-500">No suppliers yet</li>}
      </ul>
    </div>
  );
}
